import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import PaymentContainer from 'components/Checkout/Payment/PaymentContainer';
import Loader from 'components/Common/Loader/Loader';
import CheckoutTitlePage from 'components/Checkout/CheckoutTitlePage/CheckoutTitlePage';
import useCartPageStatus from 'hooks/useCartPageStatus';
import useGtmPageView from 'hooks/gtm/useGtmPageView';
import { GTM_PAGE_PAYMENT } from 'settings/gtm/gtmPageView';
import { useCustomer } from 'hooks/useCustomer';
import useCart from 'hooks/useCart';
import useCartPayment from 'hooks/checkout/useCartPayment';
import { getRoutesUri } from 'services/generic';
import { pushGtmEvent } from 'services/gtm/gtmEvents';

import styles from './page.module.scss';

export default function Payment(): JSX.Element {
  const { t } = useTranslation('checkout');
  const { cart } = useCart();
  const { paymentMethods } = useCartPayment();
  const { isLogged } = useCustomer();

  useCartPageStatus(2);
  useGtmPageView(GTM_PAGE_PAYMENT, `Afibel - ${t('PAYMENT_META_TITLE')}`);

  if (!cart || (cart && cart.status < 2) || !isLogged || !paymentMethods) {
    return (
      <>
        <RenderHelmet />
        <Loader />
      </>
    );
  }

  return (
    <>
      <RenderHelmet />
      <CheckoutTitlePage
        title={t('PAYMENT_CHECKOUT_STEP')}
        goTo={getRoutesUri<string>('checkoutShipping')}
        classes={{ container: styles.sectionTitle }}
        onClick={() =>
          pushGtmEvent({
            event: '_click_other',
            category: 'clic autre - checkout',
            element: 'retour à la livraison',
          })
        }
      />
      <PaymentContainer cart={cart} paymentMethods={paymentMethods} />
    </>
  );
}

function RenderHelmet(): JSX.Element {
  const { t } = useTranslation('checkout');

  return (
    <Helmet>
      <title>
        {t('META_TITLE_TEMPLATE', {
          title: t('PAYMENT_META_TITLE'),
          ns: 'translation',
        })}
      </title>
    </Helmet>
  );
}
